// AdminRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useLogin } from "../context/LoginContext";

const ADMIN_ROLE_ALIASES = new Set([
  "admin",
  "ROLE_ADMIN",
  "super_admin",
  "ROLE_SUPER_ADMIN",
]);

const AdminRoute = ({ children }) => {
  const { user, loading } = useLogin();

  if (loading) {
    return null;
  }

  if (!user?.authenticated) {
    return <Navigate to="/" replace />;
  }

  const userRoles = [
    user.role,
    ...(Array.isArray(user.roles) ? user.roles : []),
  ].filter(Boolean);

  const isAdmin = userRoles.some((role) => ADMIN_ROLE_ALIASES.has(role));

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
};

export default AdminRoute;
